<template>
  <v-row>

    <v-col cols="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Banner auditorio:</h3>
          </v-col>

          <v-col cols="12">
            <v-file-input
              outlined
              v-if="!auditoriums_image"
              v-model="auditoriums_image"
              :rules="rules"
              @change="onImageAuditoriumChange()"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Banner auditorio"
              :messages="['Para una mejor visualización, usar una imagen de 1120x140 px.']"
            ></v-file-input>

            <v-card
              v-if="auditoriums_image"
              wei>
              <v-img
                fixed
                :src="url_auditoriums_image"
                class="grey lighten-2"
                height="140px"
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteImageAuditorium()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 

          </v-col>

          <v-col class="pl-4 pt-8" cols="12">
            <h3 class="font-weight-regular">Banner auditorio para dispositivos moviles:</h3>
          </v-col>

          <v-col cols="12" align="center">
            <v-file-input
              outlined
              v-if="!auditoriums_image_sm"
              v-model="auditoriums_image_sm"
              :rules="rules"
              @change="onImageAuditoriumSMChange()"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Banner auditorio SM"
              :messages="['Para una mejor visualización, usar un imagen de 90x600 px.']"
            ></v-file-input>

            <v-card
              v-if="auditoriums_image_sm"
              width="600px">
              <v-img
                fixed
                :src="url_auditoriums_image_sm"
                class="grey lighten-2"
                height="80px"
                width="600px"
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteImageAuditoriumSM()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 

          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'customizationEdition', params: { id: this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_update"
        color="primary"
        @click="updateCustomizationEdition()"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="error"
      persistent
      max-width="480"
    >
      <v-card>
        <v-card-title class="text-h5">
          Advertencia
        </v-card-title>
        <v-card-text>
    
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title 
                v-for="error in errors" 
                v-bind:key="error"
                style="white-space: normal; word-break: break-word;"
                class="pt-2">
                - {{ error }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="error = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'customizationAuditorium',
    data: () => ({
      loading:true,
      loading_update: false,
      edition_id:null,
      edition:[],
      customization:[],

      home_image: null,
      url_home_image: null,

      appbar_image: null,
      url_appbar_image: null,
      appbar_dark_mode: 1,

      auditoriums_image: null,
      url_auditoriums_image: null,

      auditoriums_image_sm: null,
      url_auditoriums_image_sm: null,

      my_project_image: null,
      url_my_project_image: null,

      error:false,
      errors:[],
    }),

    methods:{
      async getCustomization(){
        await axios.get('admin/editions/'+this.edition_id+'/customization').then(response =>{
          this.edition = response.data.data
          this.customization = response.data.data.customization

          this.home_image = response.data.data.customization.home_image
          this.url_home_image = APP_URL+ this.home_image
          
          this.appbar_image = response.data.data.customization.appbar_image
          this.url_appbar_image = APP_URL+ this.appbar_image
          this.appbar_dark_mode = response.data.data.customization.appbar_dark_mode

          this.auditoriums_image = response.data.data.customization.auditoriums_image
          this.url_auditoriums_image = APP_URL+ this.auditoriums_image

          this.auditoriums_image_sm = response.data.data.customization.auditoriums_image_sm
          this.url_auditoriums_image_sm = APP_URL+ this.auditoriums_image_sm

          this.my_project_image = response.data.data.customization.my_project_image
          this.url_my_project_image = APP_URL+ this.my_project_image

          this.loading=false
        }).catch(error => {
          this.loading=false
          console.log(error);
        })
      },

      async updateCustomizationEdition(){
        this.loading_update=true
        let formData= new FormData()
        formData.append('auditoriums_image', this.auditoriums_image)
        formData.append('auditoriums_image_sm', this.auditoriums_image_sm)

        try {
          await axios({
            method: 'post',
            url: 'admin/editions/'+this.edition_id+'/customization-auditorium',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( () =>{
            this.loading_btn = false
            this.$router.push({ name: 'customizationEdition', params: { edition_id: this.edition_id } })
          })
        } catch (error) {
          console.log('Response: ')
          console.error(error.response.data);
          this.loading_update=false
          this.error = true
          this.errors = Object.values(error.response.data.errors).flat()
        }
      },

      onImageHomeChange() {
        this.url_home_image = URL.createObjectURL(this.home_image);
      },

      deleteImageHome(){
        this.home_image=null
        this.url_home_image=null
      },

      onAppBarImageChange() {
        this.url_appbar_image = URL.createObjectURL(this.appbar_image);
      },

      deleteAppBarImage(){
        this.appbar_image=null
        this.url_appbar_image=null
      },

      onImageAuditoriumChange() {
        this.url_auditoriums_image = URL.createObjectURL(this.auditoriums_image);
      },

      deleteImageAuditorium(){
        this.auditoriums_image=null
        this.url_auditoriums_image=null
      },

      //-------Auditorio SM---------

      onImageAuditoriumSMChange() {
        this.url_auditoriums_image_sm = URL.createObjectURL(this.auditoriums_image_sm);
      },

      deleteImageAuditoriumSM(){
        this.auditoriums_image_sm=null
        this.url_auditoriums_image_sm=null
      },

      //-------My Project-----------
      onProjectImageChange() {
        this.url_my_project_image = URL.createObjectURL(this.my_project_image);
      },

      deleteProjectImage(){
        this.my_project_image=null
        this.url_my_project_image=null
      }

    },

    created(){
      this.edition_id = this.$route.params.edition_id;
      this.getCustomization()
    },
  }
</script>
